import VConsole from 'vconsole'

import {
    onBroadcast,
    onBroadcastCustom,
    onWebviewshow,
    RewardJsInstall,
    RewardJsToggleCloseBtnShow,
    VideoBridgeGetFileInfo,
    VideoBridgeInit,
    VideoBridgeReportUrls,
    VideoBridgeToggleBouncesOff
} from "../../api";
import {_appendUrlParam, _device} from "../../common/m_base/util";
import {
    appendSubView,
    bringViewToFront,
    hideView,
    setViewAlpha,
    setViewScale,
    showView
} from "../../api/nativeComponent/compVisibleCommon";
import {createWebview, webviewLoad} from "../../api/nativeComponent/compWebview";
import {getCreatedInstanceId} from "../../api/apiUtil";
import {closeAd} from "../../api/nativeComponent/compCommon";
import {callDeveloperShowSucccess} from "../../api/noticeDeveloperAPI";

export default class Tpl {

    constructor(props) {
        this.childTplList = []

        let MTG_SDKContext = window.MTG_SDKContext
        if (MTG_SDKContext && MTG_SDKContext.unitId && MTG_SDKContext.unitSetting && MTG_SDKContext.sdkSetting) {
            this.unitId = MTG_SDKContext.unitId
            this.unitSetting = MTG_SDKContext.unitSetting
            this.sdkSetting = MTG_SDKContext.sdkSetting
        } else {
            console.warn('当前实例初始化失败, 缺少 MTG_SDKContext')
        }

        onBroadcast({
            cb: res => {
                console.warn('[Global]收到广播: ', res)
            }
        })
    }

    /**
     * 初始化
     * @return
     */
    init({JsBridgeRes}) {

        // 针对 Promise 添加调试监听
        window.addEventListener("unhandledrejection", event => {
            console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`, {event});
        });

        // iOS 下禁用滑动反弹
        if (_device().isiOS) {
            VideoBridgeToggleBouncesOff()
        }

        // this.bindEvent()
    }

    show(res) {
        console.log('Tpl.js: show()')
    }

    /**
     * 获取并初始化 SDK 的上下文
     * @returns {Promise<boolean|{appSetting: *, bigTemplateInstanceId: *, campaignList: *, sdkSetting: *, unitSetting: *, sdk_info: *, unit_id: *, device: *}>}
     */
    async initSDKContext() {
        const VideoBridgeRes = await VideoBridgeInit().catch(error => console.warn(error))

        if (typeof VideoBridgeRes === 'undefined') {
            console.warn('VideoBridge init 获取 SDK 上下文失败, VideoBridgeRes: ', VideoBridgeRes)
            return false
        }

        const unitId = VideoBridgeRes.unit_id
        const sdkInfo = VideoBridgeRes.sdk_info
        const {campaignList, appSetting, unitSetting, rewardSetting, sdkSetting, device} = VideoBridgeRes

        // 获取大模板的 cmptId
        const selfViewInstanceId = sdkSetting && sdkSetting.instanceId
        const rootViewInstanceId = sdkSetting && sdkSetting.rootViewInstanceId
        const playVideoMute = sdkSetting && sdkSetting.playVideoMute

        // 构建 "全局" 的上下文环境对象
        this.MTG_SDKContext = {
            campaignList,
            sdkInfo,
            unitId,
            appSetting,
            unitSetting,
            rewardSetting,
            sdkSetting,
            device,
            selfViewInstanceId,
            bigTemplateInstanceId: selfViewInstanceId,
            rootViewInstanceId,
            playVideoMute,
        }
        window.MTG_SDKContext = this.MTG_SDKContext

        // 将数据填充到 "当前实例" 的上下文中
        this.campaignList = campaignList
        this.sdkInfo = sdkInfo
        this.unitId = unitId
        this.appSetting = appSetting
        this.unitSetting = unitSetting
        this.rewardSetting = rewardSetting
        this.sdkSetting = sdkSetting
        this.device = device
        this.selfViewInstanceId = selfViewInstanceId
        this.bigTemplateInstanceId = selfViewInstanceId
        this.rootViewInstanceId = rootViewInstanceId
        this.playVideoMute = playVideoMute

        return this.MTG_SDKContext
    }

    /**
     * 绑定事件
     * @return
     */
    bindEvent() {
        this.bindPageEvent()
        this.bindNativeEvent()
    }

    bindPageEvent() {
        console.log('Tpl.js: bindPageEvent()')
    }

    bindNativeEvent() {
        console.log('onBroadcastCustom 监听中...')
        onBroadcastCustom({
            cb: res => {
                console.log(res)
            }
        })
    }

    /**
     * 安装
     * @param campaign
     */
    install(campaign) {
        console.log('触发安装: RewardJsInstall', {campaign})
        RewardJsInstall(campaign)
    }

    async showCtaBanner() {
        let unitId = this.unitId
        let rect = {left: 180, top: 400, right: 10, bottom: 200, width: 200, height: 400}

        if (typeof this.ctaBannerId !== 'string') {
            let title = 'cta banner'
            let bodyHtml = `
            <img src="https://cn.bing.com/th?id=OHR.WhiteLeviathan_ZH-CN0294518235_UHD.jpg&pid=hp&w=3840&h=2160&rs=1&c=4&r=0" style="max-width: 100%" alt="">
            <div id="closeMini" class="btn">关闭 cta banner</div>
            <div id="ctaBanner" class="btn">点击安装</div>
            <div id="log"></div>
            <style>.btn {margin: 5px;width: 100px;height: 100px; background: cyan; color: #fff;font-size: 16px;}</style>
            <script src="http://47.95.208.135/mtg-h5-test-case-demo/dist/m.bundle.js?t=${Date.now()}"></script>
            <script>
            let ctaBanner = document.getElementById('ctaBanner');
            ctaBanner.addEventListener('click', ev => {
                ctaBanner.style.fontSize = '36px'
                ctaBanner.style.color = 'yellow'
                try{
                    // TODO: about:blank 导致 localStorage 无法使用的问题
                    // localStorage.setItem('campaign', '{}')
                    // let campaign = JSON.parse(localStorage.getItem('campaign'))
                    WindVane.call('VideoBridge', 'broadcast', {"unitId":${unitId}, "eventName": "broadcastctabannerinstall", data: {campaign:{id:123456,title:'测试数据'}}}, function(res){
                        console.warn(res)
                    }, function (e) {
                        console.error(res)
                    })
                    
                    // 利用 install 的 click_url 进行跳转
                    // iOS
                    WindVane.call('RewardJs', 'install', {
                        click_url: "http://www.baidu.com",
                        link_type: 4,
                        click_mode: 6,
                        notice_url: '',
                    }, function(res) {
                        console.log('RewardJs - install - success', res)
                    }, function (e) {
                        console.error('RewardJs - install - error', e)
                    })
                    // 安卓
                    /*WindVane.call('RewardJs', 'install', {
                        click_url: "http://www.baidu.com",
                        link_type: 9,
                        click_mode: 6,
                        notice_url: '',
                    }, function(res){
                        console.log('RewardJs - install - success', res)
                    }, function (e) {
                        console.error('RewardJs - install - error', e)
                    })*/
                } catch (e) {
                  let logItem = document.createElement('div')
                  logItem.textContent = '发生错误: ' + JSON.stringify(e)
                  document.querySelector('#log').appendChild(logItem)
                }
            })
            
            // TODO 如何关闭正确的 miniendcard 的实现成本较高, 这里暂不实现
            //  需要先发一个广播带上自己的 id, 然后由自己的父组件确认并接受处理这条广播
            let closeMini = document.getElementById('closeMini');
            closeMini.addEventListener('click', ev => {
                WindVane.call('VideoBridge', 'broadcast', {"unitId":${unitId}, "eventName": "broadcastctabannerclosemini", data: {}}, function(res){
                    console.warn(res)
                }, function (e) {
                    console.error(res)
                })
            })
            </script>
            `
            let html = this.createHtmlView({title, bodyHtml})
            let preload = 2
            this.ctaBannerId = getCreatedInstanceId(await this.createWebview())
            await this.preload({id: this.ctaBannerId, html, preload, rect})
        }

        let id = this.ctaBannerId
        setTimeout(() => {
            console.warn('delay 1 秒后 append cta banner')
            this.append({parentCmptId: MTG_SDKContext.rootViewInstanceId, childCmptId: id})
        }, 1000)
    }

    hideCtaBanner() {
        let unitId = this.unitId
        let id = this.ctaBannerId
        hideView({unitId, id})
    }

    createHtmlView({title, bodyHtml}) {
        return `<!doctype html>
        <html lang="en">
        <head>
        <meta charset="UTF-8">
                     <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
                                 <meta http-equiv="X-UA-Compatible" content="ie=edge">
                     <title>${title}</title>
        </head>
        <body>
            ${bodyHtml}
        </body>
        </html>`
    }

    createWebview({fileURL, filePath, html, rect} = {}) {
        let unitId = this.unitId
        return createWebview({unitId, fileURL, filePath, html, rect})
    }

    preload({id, fileURL, filePath, html, campaigns, unitSetting, rect}) {
        let unitId = this.unitId
        let preload = 2 // 1 标识非预加载, 2 标识预加载, ios 默认为 1, android 默认就是 preload, 所以这里需要设置为 2
        return webviewLoad({unitId, id, fileURL, filePath, html, campaigns, unitSetting, preload, rect})
    }

    append({parentCmptId, childCmptId, rect}) {
        let unitId = this.unitId
        return appendSubView({unitId, parentCmptId, childCmptId, rect})
    }

    appendTo(component) {

    }

    enableDebugMode() {
        window.vConsole = new VConsole()
    }

    loadVConsole() {
        let vConsoleScript = document.createElement("script")
        vConsoleScript.src = ""
        document.body.appendChild(vConsoleScript)
        vConsoleScript.onload = function () {
            new VConsole
        }
    }

    showVideo(res) {
        console.log('----------showVideo done.')
    }

    playVideo(res) {
        console.log('----------playVideo done.')
    }

    initCloseButton() {
        // 监听 webviewshow 事件, TODO: 倒计时显示关闭按钮
        onWebviewshow(res => {
            setTimeout(() => {
                RewardJsToggleCloseBtnShow()
            }, 3000)
        })
        // 监听关闭按钮点击事件
        // onClicked()
    }

    updateSDKContext(key, value) {
        if (typeof key === 'undefined') {
            console.warn('更新 SDKContext 失败, 请传入有效的 key 值')
            return false
        }

        this[key] = value
        if (this.MTG_SDKContext) {
            this.MTG_SDKContext[key] = value
        }
        return this.MTG_SDKContext
    }

    async getFilePathByRemoteUrl(url = '') {
        let filePath = url
        let unitId = this.unitId
        let resource = [{
            type: 2,
            ref: url
        }]
        let filePathConfig = await VideoBridgeGetFileInfo({unitId, resource})
        if (filePathConfig && filePathConfig.resource && filePathConfig.resource[0] && filePathConfig.resource[0][url] && filePathConfig.resource[0][url].path) {
            filePath = filePathConfig.resource[0][url].path
        } else {
            console.warn('获取 filePath 失败: ', {url, filePathConfig})
        }
        return filePath
    }

    /**
     * 将创建成功的播放模板添加到子模板列表中, 并绑定对应的 campaign
     * @param campaignId 要绑定的 campaign id
     * @param tplInstanceId 当前创建成功的子模板实例 id
     */
    addToChildTplList(campaignId, tplInstanceId) {
        this.childTplList.push({campaignId, tplInstanceId, isPageLoadFinished: false})
    }

    setTemplateLoadFinished(campaignId) {
        let curChildTpl = this.childTplList.filter(item => item.campaignId === campaignId)
        if (curChildTpl) {
            curChildTpl.isPageLoadFinished = true
        } else {
            console.warn('设置 isPageLoadFinished 状态失败')
        }
    }

    async hideView(id) {
        let unitId = this.unitId
        await hideView({unitId, id: id || this.selfViewInstanceId})
    }

    async bringViewToFront(id) {
        let unitId = this.unitId
        await bringViewToFront({unitId, id: id || this.selfViewInstanceId})
    }

    async showView(id) {
        let unitId = this.unitId
        await showView({unitId, id: id || this.selfViewInstanceId})
    }

    async scaleView(id) {
        let unitId = this.unitId
        await setViewScale({
            unitId,
            id: id || this.selfViewInstanceId,
            vertical: .7,
            horizon: .7,
        })
    }

    async translucentView(id) {
        let unitId = this.unitId
        await setViewAlpha({
            unitId,
            id: id || this.selfViewInstanceId,
            alpha: .5
        })
    }

    closeAd() {
        let unitId = this.unitId
        return closeAd({unitId})
    }

    // 大模板被展示, 通知 SDK 上报 only impression
    reportOnlyImpression() {
        let campaign = this.campaignList && this.campaignList[0]
        let type = campaign && campaign.imp_ua;
        let url = this.generateOnlyImpressionUrl(campaign);
        // report 标记该 url 的上报类型，值为 2 表示当前上报的是 onlyImpression，
        // 背景：SDK 会针对 onlyImpression 这种业务场景拼接一些额外业务参数，如 VPN 信息(tun参数），
        // h5 如果在通过 reportUrls 接口上报 onlyImpression 的时候没有传递 report=2，
        // 就不会拼接onlyImpression相关业务参数，导致上报的业务参数缺失。
        let report = 2
        let urlsWillReport = [{type, url, report}]
        console.log('onlyimp', {urlsWillReport})
        VideoBridgeReportUrls(urlsWillReport)
    }

    // 大模板被展示, 通知 SDK 上报 pv_urls
    reportPvUrls() {
        let campaign = this.campaignList && this.campaignList[0]
        let urlsWillReport = campaign && campaign.pv_urls && campaign.pv_urls.map(url => {
            return {url}
        })
        console.log({urlsWillReport})
        VideoBridgeReportUrls(urlsWillReport)
    }

    generateOnlyImpressionUrl(campaign) {
        let onlyImpressionUrl = campaign && campaign.only_impression_url;

        /**
         * TODO onlyimp 拼接字段逻辑 - 注释待补充
         */
          // to 参数初始化, 依赖 webviewshow 时更新 expired 状态: updateCampaignExpiredState
        let key_to = 'to'
        let value_to = campaign.expired ? 1 : 0
        // console.log('generateOnlyImpressionUrl: campaign.expired: ', campaign.expired)
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_to, value_to);

        // tmorl
        // ref: http://confluence.mobvista.com/pages/viewpage.action?pageId=30350188
        let key_tmorl = 'tmorl'
        let value_tmorl = this.unitSetting && this.unitSetting.tmorl || 1
        // console.log('generateOnlyImpressionUrl: this.unitSetting && this.unitSetting.tmorl: ', this.unitSetting && this.unitSetting.tmorl)
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_tmorl, value_tmorl);

        // cbt
        let key_cbt = 'cbt'
        let value_cbt

        // 如果超时(to=1)
        if (value_to === 1) {
            // tmorl=1, 则 cbt 上报 1
            if (value_tmorl === 1) {
                // console.log('value_tmorl === 1')
                value_cbt = 1
            }
            // tmorl=2, 则 cbt 上报 0
            else if (value_tmorl === 2) {
                // console.log('value_tmorl === 2')
                value_cbt = 0
            }
        }
        // 如果没有超时(to=0)
        else if (value_to === 0) {
            // 且是 hb 的 offer, 则为 0 不走默认值逻辑（hb 需要与默认值逻辑分开，以便后续默认值更改时，后续开发者可以关注到 hb 业务是否需要单独处理）
            if (campaign.hb) {
                value_cbt = 0
            }
            // 如果没有超时且不是 hb 的单子, 则需要走默认值逻辑
            else {
                value_cbt = 0
            }
        }
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_cbt, value_cbt);

        // vt
        let key_vt = 'vt'
        let value_vt
        let allLength = this.campaignList && this.campaignList.length;
        let readyLength = this.readyCampaignList && this.readyCampaignList.length;
        let isAllCampaignReady = allLength === readyLength
        if (isAllCampaignReady) {
            value_vt = 1
        } else {
            value_vt = 2
        }
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_vt, value_vt);

        // vgc int[] example: [264393623,316549139]
        let key_vgc = 'vgc'
        let value_vgc = this.readyCampaignList && this.readyCampaignList.map(campaign => campaign.id) || []
        let vgcPrefix = '[';
        let vgcSuffix = ']';
        let separator = ',';
        value_vgc = encodeURIComponent(vgcPrefix.concat(value_vgc.join(separator)).concat(vgcSuffix))
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_vgc, value_vgc);

        // mof_tplid int
        let key_mof_tplid = 'mof_tplid'
        let value_mof_tplid = this.campaignList && this.campaignList[0] && this.campaignList[0].mof_tplid
        onlyImpressionUrl = _appendUrlParam(onlyImpressionUrl, key_mof_tplid, value_mof_tplid);

        return onlyImpressionUrl;
    }

    /**
     * 尝试从当前上下文中读取 sdkInfo, 将多余的前后缀移除, 并返回净化后的 MAJOR.MINOR.PATCH 形式版本号
     * 注意: 由于历史原因, iOS 和安卓 SDK 的版本号存在特殊前缀, 安卓大部分版本还会存在特殊后缀
     * iOS 版本号示例: MI_5.9.0
     * Android 版本号示例: MAL_12.2.0,3.0.1
     * @returns {string} 返回净化后的版本号
     */
    getPureSDKVersion() {
        let version = String(this.sdkInfo)
        // 移除 _ 前的前缀
        version = version.split('_').slice(-1)[0]
        // 移除 , 后的后缀
        version = typeof version === 'string' && version.split(',')[0]

        /**
         * 注意:
         * 安卓的版本号有一个特殊的规则, 如果测试包为 12.2.0, 则 release 包的版本号会存在两个 12.2.01 和 12.2.02,
         * 最后额外附加的数字 1 和 2 代表 SDK 投放的渠道，1 用来发国内(12.2.01), 2 用来发国外(12.2.02),
         * 所以这里判断安卓版本号的时候, 需要把最后一位 1/2 的渠道标识去掉
         */
        if (_device().isAndroid && typeof version === 'string') {
            let tmpVersion = version.slice(0, -1)
            if (tmpVersion.slice(-1) === '.') {
                console.warn('当前版本号后缀只有一位, 推测应该是安卓测试包, 不再尝试截取')
            } else {
                version = tmpVersion
            }
        }

        return version;
    }

    getCampaignExpiredState() {
        return this.campaignList && this.campaignList[0] && this.campaignList[0].expired;
    }

    /**
     * 通知 SDK 回调开发者 showsuccess, 并上报 pv 到服务端
     */
    reportTemplateShowSuccess() {
        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        let expired = this.getCampaignExpiredState()
        callDeveloperShowSucccess({unitId: this.unitId, data: {expired}})

        // 大模板被展示, 上报通知 SDK 上报 only impression
        this.reportOnlyImpression()
        this.reportPvUrls()
    }

    getCampaignByCampaignId(campaignId) {
        try {
            return this.campaignList.filter(campaign => campaign.id === campaignId)
        } catch (e) {
            console.error(e)
        }
    }

    /**
     * 在屏幕右上角显示关闭按钮
     */
    showAdCloseButtonH5() {
        console.log('显示关闭按钮')
        let adCloseButton = document.querySelector('.J_MTG_button-close-ad')
        if (adCloseButton && adCloseButton.style) {
            adCloseButton.style.display = 'block'
        } else {
            console.error('关闭按钮显示失败, 找不到对应的 DOM 节点: ', adCloseButton)
        }
    }
}